import * as XLSX from "xlsx";

export const exportManuscriptsToExcel = (data, fileName) => {
  const flattenedData = data.map((item) => ({
    Received: item?.timestamp || "",
    "Journal name": item.journal_name || "",
    "Manuscript ID": item.manuscript_id || "",
    "Manuscript title": item.title || "",
    Status: item?.match_status || "",
    Signals: Array.isArray(item?.signals) ? item.signals.join(", ") : (item?.signals || ""),
  }));

  const worksheet = XLSX.utils.json_to_sheet(flattenedData);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "DuplicateSubmissions");

  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};
